
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  display: block;
}

.link {
  position: relative;
  display: block;
  height: 100%;
  max-width: 100%;
  align-items: center;
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
  min-height:556px;
}

.text-wrapper {
  position: relative;
  display: grid;
  min-height: 100%;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  justify-content: center;
  padding-left: 2rem;
  padding-right: 2rem;
  color: var(--neutral-white);
}

@media (min-width: 768px) {

  .text-wrapper {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .text-wrapper {
    padding-left: 0px;
    padding-right: 0px;
  }
}

.text-wrapper{
  min-height:350px;
  z-index:10;
}

.text-wrapper.new-design {
  position: relative;
}

.text-wrapper.new-design {
  display: grid;
}

.text-wrapper.new-design {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

.text-wrapper.new-design {
  overflow: hidden;
}

.text-wrapper.new-design {
  padding-left: 2rem;
  padding-right: 2rem;
}

@media (min-width: 768px) {

  .text-wrapper.new-design {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}

@media (min-width: 768px) {

  .text-wrapper.new-design {
    padding-left: 0px;
    padding-right: 0px;
  }
}

.text-wrapper.new-design{
    grid-template-rows:auto minmax(0, 1fr);
  }

.text-wrapper.centered {
  position: relative;
}

.text-wrapper.centered {
  display: grid;
}

.text-wrapper.centered {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

.text-wrapper.centered {
  justify-items: center;
}

.text-wrapper.centered {
  overflow: hidden;
}

.text-wrapper.centered {
  padding-left: 2rem;
  padding-right: 2rem;
}

@media (min-width: 768px) {

  .text-wrapper.centered {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (min-width: 768px) {

  .text-wrapper.centered {
    padding-left: 0px;
    padding-right: 0px;
  }
}

.text-wrapper.left-aligned {
  position: relative;
}

.text-wrapper.left-aligned {
  display: grid;
}

.text-wrapper.left-aligned {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

.text-wrapper.left-aligned {
  justify-items: start;
}

.text-wrapper.left-aligned {
  overflow: hidden;
}

.text-wrapper.left-aligned {
  padding-left: 2rem;
  padding-right: 2rem;
}

@media (min-width: 768px) {

  .text-wrapper.left-aligned {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }
}

@media (min-width: 768px) {

  .text-wrapper.left-aligned {
    padding-left: 0px;
    padding-right: 0px;
  }
}

.text-wrapper.wide-title {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-items: center;
  overflow: hidden;
  padding-left: 4rem;
  padding-right: 4rem;
  text-align: right;
  min-height:350px;
}

.gray-overlay {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 10;
  height: 100%;
  width: 100%;
  background-color:rgba(0, 0, 0, 0.5);
}

picture img {
  position: absolute;
  width: 100%;
  object-fit: cover;
  height:100% !important;
}

.banner-heading {
  grid-column-start: 1;
  margin-top: 0.5rem;
  padding-left: 2rem;
  padding-right: 2rem;
}

@media (min-width: 768px) {

  .banner-heading {
    grid-column-start: 3;
  }

  .banner-heading {
    margin-top: 6rem;
  }

  .banner-heading {
    width: 100%;
  }

  .banner-heading {
    padding-left: 0px;
    padding-right: 0px;
  }
}

:host([centered]) .banner-heading, :host([centered='true']) .banner-heading {
  grid-column-start: 1;
  margin-top: 0.5rem;
  justify-content: center;
  padding-left: 2rem;
  padding-right: 2rem;
  text-align: center;
}

@media (min-width: 768px) {

  :host([centered]) .banner-heading, :host([centered='true']) .banner-heading {
    grid-column-start: 2;
  }

  :host([centered]) .banner-heading, :host([centered='true']) .banner-heading {
    margin-top: 0.5rem;
  }

  :host([centered]) .banner-heading, :host([centered='true']) .banner-heading {
    margin-top: 7rem;
  }

  :host([centered]) .banner-heading, :host([centered='true']) .banner-heading {
    padding-left: 0px;
    padding-right: 0px;
  }
}

.paragraph {
  grid-column-start: 1;
  display: none;
  padding: 0px;
}

@media (min-width: 768px) {

  .paragraph {
    grid-column-start: 3;
  }

  .paragraph {
    display: block;
  }

  .paragraph {
    width: 100%;
  }

  .paragraph {
    padding-left: 0px;
    padding-right: 0px;
  }
}

:host([centered]) .paragraph, :host([centered='true']) .paragraph {
  grid-column-start: 1;
  justify-content: center;
  padding-left: 2rem;
  padding-right: 2rem;
  text-align: center;
}

@media (min-width: 768px) {

  :host([centered]) .paragraph, :host([centered='true']) .paragraph {
    grid-column-start: 2;
  }

  :host([centered]) .paragraph, :host([centered='true']) .paragraph {
    padding-left: 0px;
    padding-right: 0px;
  }
}

.cta {
  grid-column-start: 1;
  margin-bottom: 7rem;
  margin-top: 0.75rem;
  display: block;
  width: 100%;
  padding-left: 2rem;
  padding-right: 2rem;
}

@media (min-width: 768px) {

  .cta {
    grid-column-start: 3;
  }

  .cta {
    padding-left: 0px;
    padding-right: 0px;
  }
}

@media (min-width: 1024px) {

  .cta {
    white-space: nowrap;
  }
}

.text-wrapper.wide-title.cta {
  display: flex;
  justify-content: center;
}

:host([centered]) .cta, :host([centered='true']) .cta {
  grid-column-start: 1;
  margin-top: 2rem;
  justify-content: center;
  padding-left: 2rem;
  padding-right: 2rem;
  text-align: center;
}

@media (min-width: 768px) {

  :host([centered]) .cta, :host([centered='true']) .cta {
    grid-column-start: 2;
  }

  :host([centered]) .cta, :host([centered='true']) .cta {
    padding-left: 0px;
    padding-right: 0px;
  }
}

:host([centered]) .wide-title .cta, :host([centered='true']) .wide-title .cta {
  display: flex;
  justify-content: center;
  padding-left: 0px;
  padding-right: 0px;
}

.new-design {
  min-height: 410px;
}

.new-design .banner-heading {
  margin-top: 20rem;
}

.new-design .banner-heading {
  color: var(--neutral-white);
}

@media (min-width: 768px) {

  .new-design .banner-heading {
    margin-top: 3rem;
  }
}

.new-design .paragraph {
  color: var(--neutral-white);
}

.new-design .banner-heading, .new-design .paragraph, .new-design .cta {
  grid-column-start: 1;
}

.new-design .banner-heading, .new-design .paragraph, .new-design .cta {
  text-align: center;
}

@media (min-width: 768px) {

  .new-design .banner-heading, .new-design .paragraph, .new-design .cta {
    grid-column-start: 5;
  }
}

@media (min-width: 768px) {

  .new-design .banner-heading, .new-design .paragraph, .new-design .cta {
    grid-column-end: 11;
  }
}

@media (min-width: 768px) {

  .new-design .banner-heading, .new-design .paragraph, .new-design .cta {
    text-align: right;
  }
}

@media (min-width: 1024px) {

  .new-design .banner-heading, .new-design .paragraph, .new-design .cta {
    grid-column-start: 7;
  }
}

.new-design .paragraph, .new-design .cta {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.new-design .cta {
  margin-bottom: 0px;
}

@media (min-width: 768px) {

  .new-design .cta {
    margin-bottom: 3rem;
  }
}

.new-design picture img {
  max-height: 24rem;
}

.new-design picture img {
  object-position: center;
}

@media (min-width: 768px) {

  .new-design picture img {
    max-height: 100%;
  }
}

:host([centered]) .banner-heading, :host([centered]) .paragraph, :host([centered]) .cta, :host([centered='true']) .banner-heading, :host([centered='true']) .paragraph, :host([centered='true']) .cta {
  grid-column-end: 2;
}

:host([centered]) .banner-heading, :host([centered]) .paragraph, :host([centered]) .cta, :host([centered='true']) .banner-heading, :host([centered='true']) .paragraph, :host([centered='true']) .cta {
  display: flex;
}

:host([left-aligned]) .banner-heading, :host([left-aligned='true']) .banner-heading {
  grid-column-start: 1;
  margin-top: 0.5rem;
  justify-content: flex-start;
  padding-left: 2rem;
  padding-right: 2rem;
  text-align: left;
}

@media (min-width: 768px) {

  :host([left-aligned]) .banner-heading, :host([left-aligned='true']) .banner-heading {
    grid-column-start: 2;
  }

  :host([left-aligned]) .banner-heading, :host([left-aligned='true']) .banner-heading {
    grid-column-end: 8;
  }

  :host([left-aligned]) .banner-heading, :host([left-aligned='true']) .banner-heading {
    margin-top: 7rem;
  }

  :host([left-aligned]) .banner-heading, :host([left-aligned='true']) .banner-heading {
    padding-left: 0px;
    padding-right: 0px;
  }
}

@media (min-width: 1024px) {

  :host([left-aligned]) .banner-heading, :host([left-aligned='true']) .banner-heading {
    grid-column-end: 7;
  }
}

:host([left-aligned]) .paragraph, :host([left-aligned='true']) .paragraph {
  grid-column-start: 1;
  justify-content: flex-start;
  padding: 0px;
  text-align: left;
}

@media (min-width: 768px) {

  :host([left-aligned]) .paragraph, :host([left-aligned='true']) .paragraph {
    grid-column-start: 2;
  }

  :host([left-aligned]) .paragraph, :host([left-aligned='true']) .paragraph {
    grid-column-end: 8;
  }

  :host([left-aligned]) .paragraph, :host([left-aligned='true']) .paragraph {
    padding-left: 0px;
    padding-right: 0px;
  }
}

@media (min-width: 1024px) {

  :host([left-aligned]) .paragraph, :host([left-aligned='true']) .paragraph {
    grid-column-end: 7;
  }
}

:host([left-aligned]) .cta, :host([left-aligned='true']) .cta {
  grid-column-start: 1;
  margin-top: 2rem;
  justify-content: flex-start;
  padding-left: 2rem;
  padding-right: 2rem;
  text-align: left;
}

@media (min-width: 768px) {

  :host([left-aligned]) .cta, :host([left-aligned='true']) .cta {
    grid-column-start: 2;
  }

  :host([left-aligned]) .cta, :host([left-aligned='true']) .cta {
    grid-column-end: 8;
  }

  :host([left-aligned]) .cta, :host([left-aligned='true']) .cta {
    padding-left: 0px;
    padding-right: 0px;
  }
}

@media (min-width: 1024px) {

  :host([left-aligned]) .cta, :host([left-aligned='true']) .cta {
    grid-column-end: 7;
  }
}

:host([left-aligned]) .wide-title .cta, :host([left-aligned='true']) .wide-title .cta {
  display: flex;
  justify-content: flex-start;
  padding-left: 0px;
  padding-right: 0px;
}`;